// extracted by mini-css-extract-plugin
export default {"zoomModal":"E2-z"};